'use client';

import type { ReactNode } from 'react';

import classnames from 'classnames';
import { FaSpinner } from 'react-icons/fa';

import { Icon } from '../icon';
import type { ButtonAppearanceProps } from './Button.types';

import styles from './Button.module.scss';

type ButtonClassesProps = Pick<
  ButtonAppearanceProps,
  'variant' | 'size' | 'shadow' | 'disabled' | 'loading'
> & {
  className?: string;
};

export function buttonClasses({
  variant,
  size,
  shadow,
  disabled,
  loading,
  className,
}: ButtonClassesProps) {
  return classnames(
    styles['button'],
    variant && styles[`button--${variant}`],
    size && styles[`button--${size}`],
    disabled && styles['button--disabled'],
    shadow && styles['button--shadow'],
    loading && styles['button--loading'],
    className,
  );
}

type ButtonContentProps = Pick<
  ButtonAppearanceProps,
  'prefixIcon' | 'suffixIcon' | 'loading'
> & {
  testId: string;
  children?: ReactNode;
};

export function ButtonContent({
  prefixIcon,
  suffixIcon,
  loading,
  testId,
  children,
}: ButtonContentProps) {
  return (
    <>
      {loading && (
        <FaSpinner className={styles['spinner']} aria-label="spinner" />
      )}
      {prefixIcon && (
        <Icon
          size="sm"
          icon={prefixIcon}
          data-testid={`${testId}_prefix`}
          className={classnames(loading && styles['icon--loading'])}
        />
      )}
      <span
        className={classnames(
          styles['label'],
          loading && styles['label--loading'],
        )}
      >
        {children}
      </span>
      {suffixIcon && (
        <Icon
          size="sm"
          icon={suffixIcon}
          data-testid={`${testId}_suffix`}
          className={classnames(loading && styles['icon--loading'])}
        />
      )}
    </>
  );
}
